module.exports = "/images/environment.svg?da36ac1d9c1bbb9f4d87ae476b6c487d";